import React, { useState } from 'react'

const HelpPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('faq')
  const [searchTerm, setSearchTerm] = useState('')

  const faqData = [
    {
      category: 'Akun & Login',
      questions: [
        {
          q: 'Bagaimana cara membuat akun?',
          a: 'Klik tombol "Daftar" di pojok kanan atas, isi form dengan email, password, dan nama lengkap Anda. Setelah itu, verifikasi email Anda untuk mengaktifkan akun.'
        },
        {
          q: 'Lupa password, bagaimana cara reset?',
          a: 'Klik "Lupa Password" di halaman login, masukkan email Anda, dan ikuti instruksi yang dikirim ke email untuk reset password.'
        },
        {
          q: 'Apa itu Two-Factor Authentication (2FA)?',
          a: '2FA adalah lapisan keamanan tambahan yang memerlukan kode verifikasi dari email atau SMS selain password untuk login. Sangat disarankan untuk mengaktifkannya.'
        },
        {
          q: 'Bagaimana cara mengaktifkan 2FA?',
          a: 'Masuk ke Profile → Security Settings → Enable 2FA. Pilih metode verifikasi (email/SMS) dan ikuti instruksi yang diberikan.'
        }
      ]
    },
    {
      category: 'Pembelian & Pembayaran',
      questions: [
        {
          q: 'Metode pembayaran apa saja yang tersedia?',
          a: 'Kami menerima kartu kredit/debit, transfer bank, e-wallet (OVO, GoPay, DANA), dan QRIS. Semua pembayaran diproses melalui Midtrans yang aman.'
        },
        {
          q: 'Apakah pembayaran saya aman?',
          a: 'Ya, sangat aman. Kami menggunakan Midtrans yang bersertifikat PCI DSS dan semua data pembayaran dienkripsi dengan standar industri.'
        },
        {
          q: 'Berapa lama proses pembayaran?',
          a: 'Pembayaran kartu kredit dan e-wallet biasanya instan. Transfer bank dapat memakan waktu 1-3 jam kerja untuk konfirmasi.'
        },
        {
          q: 'Bagaimana cara mendapatkan invoice?',
          a: 'Invoice otomatis dikirim ke email Anda setelah pembayaran berhasil. Anda juga dapat mengunduhnya dari halaman "Pesanan Saya".'
        }
      ]
    },
    {
      category: 'Produk Digital',
      questions: [
        {
          q: 'Bagaimana cara mengunduh produk yang sudah dibeli?',
          a: 'Setelah pembayaran berhasil, masuk ke "Pesanan Saya" dan klik tombol "Download" pada produk yang ingin diunduh.'
        },
        {
          q: 'Berapa kali saya bisa mengunduh produk?',
          a: 'Anda dapat mengunduh produk yang sudah dibeli kapan saja tanpa batas, selama akun Anda masih aktif.'
        },
        {
          q: 'Format file apa saja yang tersedia?',
          a: 'Tergantung produk: E-book (PDF, EPUB, MOBI), Software (EXE, ZIP), Video Course (MP4), dan lainnya sesuai deskripsi produk.'
        },
        {
          q: 'Apakah saya bisa membagikan produk yang sudah dibeli?',
          a: 'Tidak, produk hanya untuk penggunaan pribadi. Membagikan atau menjual kembali melanggar syarat dan ketentuan kami.'
        }
      ]
    },
    {
      category: 'Keamanan',
      questions: [
        {
          q: 'Bagaimana jika akun saya terkunci?',
          a: 'Akun terkunci otomatis setelah 5 percobaan login gagal. Tunggu 30 menit atau hubungi support untuk membuka kunci lebih cepat.'
        },
        {
          q: 'Apa yang harus dilakukan jika akun diretas?',
          a: 'Segera hubungi support@hilaltechnologic.info dan ganti password. Aktifkan 2FA untuk keamanan tambahan.'
        },
        {
          q: 'Bagaimana cara melaporkan aktivitas mencurigakan?',
          a: 'Kirim email ke security@hilaltechnologic.info dengan detail aktivitas yang mencurigakan. Tim keamanan akan menindaklanjuti dalam 24 jam.'
        }
      ]
    }
  ]

  const contactMethods = [
    {
      title: 'Email Support',
      description: 'Untuk pertanyaan umum dan bantuan teknis',
      contact: 'support@hilaltechnologic.info',
      responseTime: '1-3 hari kerja',
      icon: '📧'
    },
    {
      title: 'Security Issues',
      description: 'Untuk masalah keamanan dan laporan vulnerability',
      contact: 'security@hilaltechnologic.info',
      responseTime: '24 jam',
      icon: '🔒'
    },
    {
      title: 'Legal & Privacy',
      description: 'Untuk pertanyaan hukum dan privasi',
      contact: 'legal@hilaltechnologic.info',
      responseTime: '3-5 hari kerja',
      icon: '⚖️'
    },
    {
      title: 'Business Inquiry',
      description: 'Untuk kerjasama dan partnership',
      contact: 'business@hilaltechnologic.info',
      responseTime: '5-7 hari kerja',
      icon: '🤝'
    }
  ]

  const troubleshooting = [
    {
      problem: 'Tidak bisa login',
      solutions: [
        'Pastikan email dan password benar',
        'Cek apakah akun terkunci (tunggu 30 menit)',
        'Clear browser cache dan cookies',
        'Coba browser lain atau mode incognito',
        'Reset password jika masih bermasalah'
      ]
    },
    {
      problem: 'Pembayaran gagal',
      solutions: [
        'Pastikan saldo atau limit kartu mencukupi',
        'Cek koneksi internet stabil',
        'Coba metode pembayaran lain',
        'Hubungi bank untuk konfirmasi transaksi',
        'Tunggu beberapa menit dan coba lagi'
      ]
    },
    {
      problem: 'Tidak bisa download produk',
      solutions: [
        'Pastikan pembayaran sudah berhasil',
        'Refresh halaman "Pesanan Saya"',
        'Cek koneksi internet',
        'Disable ad blocker atau antivirus sementara',
        'Coba browser lain'
      ]
    },
    {
      problem: 'File rusak atau tidak bisa dibuka',
      solutions: [
        'Download ulang file tersebut',
        'Pastikan aplikasi pembaca file sudah terinstall',
        'Cek ukuran file apakah sesuai',
        'Scan file dengan antivirus',
        'Hubungi support jika masih bermasalah'
      ]
    }
  ]

  const filteredFAQ = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(
      item => 
        item.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.a.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.questions.length > 0)

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Pusat Bantuan</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Temukan jawaban untuk pertanyaan Anda atau hubungi tim support kami untuk bantuan lebih lanjut.
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-md mx-auto mb-8">
          <div className="relative">
            <input
              type="text"
              placeholder="Cari bantuan..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-400">🔍</span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
            <button
              onClick={() => setActiveTab('faq')}
              className={`px-6 py-2 rounded-md font-medium transition-colors ${
                activeTab === 'faq'
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              FAQ
            </button>
            <button
              onClick={() => setActiveTab('troubleshooting')}
              className={`px-6 py-2 rounded-md font-medium transition-colors ${
                activeTab === 'troubleshooting'
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Troubleshooting
            </button>
            <button
              onClick={() => setActiveTab('contact')}
              className={`px-6 py-2 rounded-md font-medium transition-colors ${
                activeTab === 'contact'
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Kontak
            </button>
          </div>
        </div>

        {/* FAQ Tab */}
        {activeTab === 'faq' && (
          <div className="space-y-8">
            {filteredFAQ.map((category, categoryIndex) => (
              <div key={categoryIndex} className="bg-white rounded-lg shadow-sm border">
                <div className="bg-gray-50 px-6 py-4 border-b">
                  <h2 className="text-xl font-semibold text-gray-900">{category.category}</h2>
                </div>
                <div className="divide-y divide-gray-200">
                  {category.questions.map((item, index) => (
                    <details key={index} className="group">
                      <summary className="px-6 py-4 cursor-pointer hover:bg-gray-50 transition-colors">
                        <div className="flex items-center justify-between">
                          <h3 className="font-medium text-gray-900">{item.q}</h3>
                          <span className="ml-6 flex-shrink-0 text-gray-400 group-open:rotate-180 transition-transform">
                            ▼
                          </span>
                        </div>
                      </summary>
                      <div className="px-6 pb-4">
                        <p className="text-gray-600 leading-relaxed">{item.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            ))}
            
            {filteredFAQ.length === 0 && searchTerm && (
              <div className="text-center py-12">
                <div className="text-6xl mb-4">🔍</div>
                <h3 className="text-xl font-medium text-gray-900 mb-2">Tidak ada hasil ditemukan</h3>
                <p className="text-gray-600">Coba kata kunci lain atau hubungi support kami.</p>
              </div>
            )}
          </div>
        )}

        {/* Troubleshooting Tab */}
        {activeTab === 'troubleshooting' && (
          <div className="grid md:grid-cols-2 gap-6">
            {troubleshooting.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm border p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-red-500 mr-2">⚠️</span>
                  {item.problem}
                </h3>
                <div className="space-y-2">
                  <h4 className="font-medium text-gray-700">Solusi:</h4>
                  <ol className="list-decimal list-inside space-y-1">
                    {item.solutions.map((solution, sIndex) => (
                      <li key={sIndex} className="text-gray-600 text-sm">{solution}</li>
                    ))}
                  </ol>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Contact Tab */}
        {activeTab === 'contact' && (
          <div className="space-y-8">
            <div className="grid md:grid-cols-2 gap-6">
              {contactMethods.map((method, index) => (
                <div key={index} className="bg-white rounded-lg shadow-sm border p-6">
                  <div className="flex items-start space-x-4">
                    <div className="text-3xl">{method.icon}</div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{method.title}</h3>
                      <p className="text-gray-600 mb-3">{method.description}</p>
                      <div className="space-y-2">
                        <div className="flex items-center space-x-2">
                          <span className="text-sm font-medium text-gray-700">Kontak:</span>
                          <a 
                            href={`mailto:${method.contact}`}
                            className="text-blue-600 hover:text-blue-800 text-sm"
                          >
                            {method.contact}
                          </a>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className="text-sm font-medium text-gray-700">Response:</span>
                          <span className="text-sm text-gray-600">{method.responseTime}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Kirim Pesan</h3>
              <form className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nama</label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Nama lengkap Anda"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="email@example.com"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Kategori</label>
                  <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                    <option>Pilih kategori...</option>
                    <option>Masalah Teknis</option>
                    <option>Pertanyaan Pembayaran</option>
                    <option>Masalah Keamanan</option>
                    <option>Saran & Feedback</option>
                    <option>Lainnya</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Pesan</label>
                  <textarea
                    rows={5}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Jelaskan masalah atau pertanyaan Anda dengan detail..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
                >
                  Kirim Pesan
                </button>
              </form>
            </div>

            {/* Emergency Contact */}
            <div className="bg-red-50 border border-red-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-red-900 mb-2 flex items-center">
                <span className="mr-2">🚨</span>
                Kontak Darurat
              </h3>
              <p className="text-red-700 mb-3">
                Untuk masalah keamanan yang mendesak atau akun yang diretas:
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <span className="font-medium text-red-900">Email:</span>
                  <a href="mailto:emergency@hilaltechnologic.info" className="text-red-600 hover:text-red-800">
                    emergency@hilaltechnologic.info
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="font-medium text-red-900">Response:</span>
                  <span className="text-red-700">Dalam 2-4 jam</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Quick Links */}
        <div className="mt-12 bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Link Berguna</h3>
          <div className="grid md:grid-cols-3 gap-4">
            <a href="/privacy" className="flex items-center space-x-2 text-blue-600 hover:text-blue-800">
              <span>🔒</span>
              <span>Kebijakan Privasi</span>
            </a>
            <a href="/terms" className="flex items-center space-x-2 text-blue-600 hover:text-blue-800">
              <span>📋</span>
              <span>Syarat & Ketentuan</span>
            </a>
            <a href="/profile" className="flex items-center space-x-2 text-blue-600 hover:text-blue-800">
              <span>👤</span>
              <span>Pengaturan Akun</span>
            </a>
          </div>
      </div>
    </div>
  )
}

export default HelpPage
